import { render, staticRenderFns } from "./Linkbutton.vue?vue&type=template&id=6f872950&scoped=true&"
import script from "./Linkbutton.vue?vue&type=script&lang=ts&"
export * from "./Linkbutton.vue?vue&type=script&lang=ts&"
import style0 from "./Linkbutton.vue?vue&type=style&index=0&id=6f872950&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f872950",
  null
  
)

export default component.exports